import React, { forwardRef } from "react"
import { Link as GatsbyLink } from "gatsby"

export interface LinkProps {
  href: string
  onClick?: () => void
  id?: string
  style?: { [key: string]: string }
  children?: React.ReactChild
  color?: string
  ariaLabel?: string
  fontWeight?: number
  // NOTE force as external link, used in the bottom section of footer
  isExternal?: boolean
  openWithSameTab?: boolean
}

const Link = forwardRef<any, LinkProps>(
  (
    {
      href,
      id,
      style,
      isExternal,
      children,
      ariaLabel,
      openWithSameTab = false,
      ...restProps
    }: LinkProps,
    ref
  ) => {
    if (
      isExternal ||
      (href &&
        (href.startsWith("http") ||
          href.startsWith("mailto:") ||
          // NOTE removed header and footer on all `/privacy/xxx` path page, therefore need a new tab for privacies
          href.startsWith("/privacy")))
    ) {
      const relAttrib = !openWithSameTab
        ? { target: "_blank", rel: "noopener noreferrer" }
        : { rel: "noreferrer" }

      return (
        <a
          href={href}
          id={id}
          {...relAttrib}
          style={style}
          aria-label={ariaLabel}
          ref={ref}
          {...restProps}
        >
          {children}
        </a>
      )
    }

    return (
      <GatsbyLink to={href} activeStyle={style} ref={ref} {...restProps}>
        {children}
      </GatsbyLink>
    )
  }
)

Link.displayName = "Link"

export default Link
